import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { switchMap } from 'rxjs/operators';

import { ActorType } from 'app/core/actor-type';
import { ConfigService } from 'app/core/config.service';


@Injectable()
export class ActorTypeService {

  constructor(private http: HttpClient, private configService: ConfigService) { }

  getActorTypes(): Observable<ActorType[]> {
    return this.configService.getConfigAsync().pipe(
      switchMap(config => 
        this.http.get<ActorType[]>(config.portalApiEndpoint + `actortype`)
      )
    );
  }
}
